module.exports = __webpack_public_path__ + "img/advantage.f1b9108d.png";